import React from "react";
type SVGEmailProps = { className?: string };
const SVGEmail: React.FC<SVGEmailProps> = (props) => (
	<svg
		width="16"
		height="13"
		viewBox="0 0 16 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props?.className}
	>
		<path
			d="M1.33301 3.16669L6.77629 6.97698C7.21707 7.28553 7.43746 7.4398 7.67718 7.49956C7.88894 7.55234 8.11041 7.55234 8.32217 7.49956C8.56189 7.4398 8.78228 7.28553 9.22306 6.97698L14.6663 3.16669M4.53301 11.8334H11.4663C12.5864 11.8334 13.1465 11.8334 13.5743 11.6154C13.9506 11.4236 14.2566 11.1177 14.4484 10.7413C14.6663 10.3135 14.6663 9.75346 14.6663 8.63335V4.36669C14.6663 3.24658 14.6663 2.68653 14.4484 2.25871C14.2566 1.88238 13.9506 1.57642 13.5743 1.38467C13.1465 1.16669 12.5864 1.16669 11.4663 1.16669H4.53301C3.4129 1.16669 2.85285 1.16669 2.42503 1.38467C2.0487 1.57642 1.74274 1.88238 1.55099 2.25871C1.33301 2.68653 1.33301 3.24658 1.33301 4.36669V8.63335C1.33301 9.75346 1.33301 10.3135 1.55099 10.7413C1.74274 11.1177 2.0487 11.4236 2.42503 11.6154C2.85285 11.8334 3.4129 11.8334 4.53301 11.8334Z"
			stroke="#344054"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default SVGEmail;
